import useBestSellingProductsTableColumns from "../hooks/useBestSellingProductsTableColumns";
import useDashboardApi from "../hooks/useDashboardApi";
import { DATE_FORMAT_API } from "config/settings";
import { TableFilter } from "@neonumy/ant-design";
import { useTranslation } from "react-i18next";
import { Card, Col, Select, Empty, Spin } from "antd";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import dayjs from "dayjs";
import { FaBoxOpen } from "react-icons/fa";
import CardTitle from "components/CardTitle";

interface BestSellingProductsPropsType {
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
}

export default function BestSellingProducts(props: BestSellingProductsPropsType) {
  const { startDate, endDate } = props;
  const { t } = useTranslation();
  const urlParams: RouteParams = useParams();

  const {
    listTopSellProducts,
    refetchListTopSellProducts: refetch,
    listTopSellProductsData: dataSource,
    loadingListTopSellProducts: loading,
  } = useDashboardApi();

  const columns = useBestSellingProductsTableColumns();

  useEffect(() => {
    if (urlParams?.companyId) {
      listTopSellProducts({
        variables: {
          filter: {
            companyId: urlParams?.companyId,
            endDate: endDate && dayjs(endDate).format(DATE_FORMAT_API),
            startDate: startDate && dayjs(startDate).format(DATE_FORMAT_API),
            maxResults: 5,
          },
        },
      });
    }
  }, [urlParams?.companyId, startDate, endDate]);

  const handleOnChange = (value: number) => {
    refetch({
      filter: {
        companyId: urlParams?.companyId,
        startDate:
          dayjs(startDate)?.format(DATE_FORMAT_API) ||
          dayjs().subtract(2, "month").startOf("month").format(DATE_FORMAT_API),
        endDate: dayjs(endDate)?.format(DATE_FORMAT_API) || dayjs().format(DATE_FORMAT_API),
        maxResults: value,
      },
    });
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="chart-loading-container">
          <Spin size="large" />
        </div>
      );
    }

    if (!dataSource || dataSource.length === 0) {
      return (
        <div className="chart-empty-container">
          <Empty description={t("No data available")} image={Empty.PRESENTED_IMAGE_SIMPLE} />
        </div>
      );
    }

    return (
      <TableFilter
        className="antd-newrai-table"
        scroll={{ x: 576 }}
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        size="small"
      />
    );
  };

  return (
    <Col md={12} sm={24} xs={24}>
      <Card
        className="antd-newrai-card line-chart-card"
        title={<CardTitle icon={<FaBoxOpen />} title={t("Best-selling products")} />}
        extra={
          <div className="pie-chart-controls">
            <Select
              className="client-count-select"
              onChange={handleOnChange}
              defaultValue={5}
              options={[
                { label: "5", value: 5 },
                { label: "10", value: 10 },
                { label: "25", value: 25 },
                { label: "50", value: 50 },
                { label: "100", value: 100 },
              ]}
              dropdownMatchSelectWidth={false}
            />
          </div>
        }
      >
        {renderContent()}
      </Card>
    </Col>
  );
}
